import { Backdrop, Box, Grid, Link as MuiLink } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import { searchData, submitFormData } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as loading } from "src/app-redux/warehouse/wareHouseSlice";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { NodWereHouseRoute } from "../../nod-were-house.routes";
import { columns } from "./components/columns";
import { useStyles } from "./style";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { number, object, string } from "yup";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function BincardItems({}: Props): React.ReactElement {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(15);

  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const [moduleName, setmoduleName] = useState<any>(NodWereHouseRoute.title);
  const [pageHeading, setpageHeading] = useState<any>(
    NodWereHouseRoute.subRoutes ? NodWereHouseRoute.subRoutes[4].title : "Page Title"
  );
  const [loader2, setLoader2] = useState<any>(false);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loader: any = useAppSelector(loading);
  const [loader3, setLoader3] = useState(false);

  const [cargoTypeData, setCargoTypeData] = React.useState<any>([]);
  const [supplierTypeList, setSupplierTypeList] = React.useState<any>([]);

  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }

  const validationSchema = object({
    supplierName: string().required("This field is required."),
    inventoryNameId: number().required("This field is required."),
    startDate: string().required("This field is required."),
    endDate: string().required("This field is required."),
  });

  const formik = useFormik({
    initialValues: {
      supplierName: 0,
      inventoryNameId: "",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { startDate, endDate, supplierName, inventoryNameId } = values;
      const body = {
        startDate: startDate || null,
        endDate: endDate || null,
        supplierName: supplierName || 0,
        inventoryNameId: inventoryNameId || null,
      };
      setGridRecord([]);
      setLoader2(true);
      try {
        const results: any = await dispatch(
          submitFormData("/get-inventory-bin-card", JSON.stringify(body))
        );
        setGridRecord(results.inventoryBinCardList);
      } catch (error) {
        setLoader2(false);
      }
      setLoader2(false);
    },
  });
  const { values, setValues } = formik;

  const resetSearch = () => {
    setValues(formik.initialValues);
    formik.resetForm();
    setGridRecord([]);
  };

  // cargo type
  const getVehicleConfiguration = async () => {
    try {
      setLoader3(true);
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        const data = [...results.value.cargoTypeData, ...results.value.bannedItemData];
        setCargoTypeData(data);
        setLoader3(false);
        return;
      }
    } catch (error: any) {
      setLoader3(false);
    }
  };

  const getListing = async () => {
    let results: any = [];
    try {
      results = await fetchWrapper.get(`get_all-supplier-details?getActiveSuppliersOnly=${true}`);
      if (results.isSuccess == true) {
        results.value.sort((a: any, b: any) => b.supplierType.localeCompare(a.supplierType));
        const all = { id: 0, supplierName: "All" };
        setSupplierTypeList([all, ...results.value]);
      }
      return;
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };

  useEffect(() => {
    getVehicleConfiguration();
    getListing();
  }, []);

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={pageSize}
            loader={loader2}
            height={550}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonTextFieldDate
                  required
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                  error={formik.touched.startDate && Boolean(formik.errors.startDate)}
                  helperText={formik.touched.startDate && formik.errors.startDate}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonTextFieldDate
                  required
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment(
                    new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)
                  ).format("YYYY-MM-DDTHH:mm")}
                  error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                  helperText={formik.touched.endDate && formik.errors.endDate}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonAutoCompleteField
                  required
                  cssClassName="customTextField"
                  label="Select Item"
                  name="inventoryNameId"
                  optionsType={cargoTypeData}
                  placeholder="Select Item"
                  getOptionLabel={(option: any) => option.name || ""}
                  value={cargoTypeData?.find((st: any) => st.id === formik.values.inventoryNameId)}
                  onChange={(option: any) => {
                    if (option && option.id !== 0) {
                      formik.setFieldValue("inventoryNameId", option.id);
                    }
                  }}
                  error={formik.touched.inventoryNameId && Boolean(formik.errors.inventoryNameId)}
                  helperText={formik.touched.inventoryNameId && formik.errors.inventoryNameId}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonAutoCompleteField
                  required
                  cssClassName="customTextField"
                  label="By/From"
                  placeholder="Select Importer/Exporter Name"
                  name="supplierName"
                  optionsType={supplierTypeList}
                  getOptionLabel={(option: any) =>
                    option.supplierName && option.supplierType
                      ? `${option.supplierType} - ${option.supplierName}`
                      : option.supplierName
                      ? option.supplierName
                      : ""
                  }
                  renderOption={(option) => (
                    <span>
                      {option.supplierName && option.supplierType
                        ? `${option.supplierType} - ${option.supplierName}`
                        : option.supplierName
                        ? option.supplierName
                        : ""}
                    </span>
                  )}
                  value={
                    supplierTypeList.find((st: any) => st.id === formik.values.supplierName) || null
                  }
                  onChange={(option: any) => {
                    option && option !== "" ? formik.setFieldValue("supplierName", option.id) : "";
                  }}
                  error={formik.touched.supplierName && Boolean(formik.errors.supplierName)}
                  helperText={formik.touched.supplierName && formik.errors.supplierName}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4} lg={4} direction="row">
              <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => formik.submitForm()}
                >
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
